import { isValid, differenceInYears, parse } from 'date-fns'
import { FormikErrors, FormikValues } from 'formik'
import * as Yup from 'yup'

import { InputProps } from '~/components'

export interface InputValidationProps extends InputProps {
  values: FormikValues
  errors: FormikErrors<InputValidationProps['values']>
}
const NO_EMOJIS_REGEX =
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
const noEmojis = (value = '') => !NO_EMOJIS_REGEX.test(value)

export const firstNameSchema = Yup.string()
  .required('First name is required')
  .min(2, 'Too short!')
  .max(50, 'Too long!')

export const lastNameSchema = Yup.string()
  .required('Last name is required')
  .min(2, 'Too short!')
  .max(50, 'Too long!')

export const dobSchema = Yup.string()
  .required('Birth date is required')
  .test('Invalid Date', 'Must be a valid date (MM/DD/YYYY)', (value = '') => {
    return value.trim().length === 10 && isValid(parse(value, 'MM/dd/yyyy', new Date()))
  })
  .test('Not Old Enough', 'Must be at least 18 years old', (value = '') => {
    return differenceInYears(new Date(), parse(value, 'MM/dd/yyyy', new Date())) >= 18
  })
  .test('Invalid Date', 'Please enter a valid date', (value = '') => {
    return differenceInYears(new Date(), parse(value, 'MM/dd/yyyy', new Date())) <= 110
  })

export const PreferredLanguageOtherSchema = Yup.string()
  .required('Please tell us your preferred language for care')
  .test(
    'No Special Characters',
    'Preferred language cannot include numbers or special characters.',
    noEmojis,
  )
  .min(2, 'Preferred language must be at least 2 characters.')

export const insurancePayerSchema = Yup.object()
  .shape({
    fireflyAccepted: Yup.boolean(),
    name: Yup.string(),
    elationPayerCode: Yup.string(),
    label: Yup.string(),
    value: Yup.string(),
    id: Yup.string() || Yup.number(),
  })
  .required('Please select your insurance provider')
  .nullable()

export const memberIdSchema = Yup.string()
  .required('Member ID Number is required')
  .test(
    'Invalid Member ID Number',
    'Please enter the correct Member ID Number',
    (value: string = '') => {
      return value.replace(/\s+/g, '').length >= 1
    },
  )
